import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

import lang from '@/lang'

import PageWrapper from '@/modules/base/components/modalWizard/pageWrapper'
import Radio from '../radio'
import useCreateUser from './context'
import { CONNECTION_TYPE_OFFLINE, CONNECTION_TYPE_ONLINE } from '@/modules/client/constants'
import RadioContent from '@/modules/client/components/list/radio/content'

const Connection = (props) => {
  const { onClose, updateSteps, invitationMode } = props
  const { client, patch } = useCreateUser()
  const classes = useStyles()

  const validationSchema = Yup.object({
    connectionType: Yup.string().required(),
  })

  return (
    <Formik
      initialValues={client}
      onSubmit={patch}
      enableReinitialize
      validationSchema={validationSchema}
      validateOnMount
    >
      {({ handleSubmit, handleChange, values, isValid }) => {
        const onChange = (e) => {
          updateSteps(e.target.value)
          handleChange(e)
        }

        return (
          <PageWrapper
            heading={lang.createClient.connection.heading}
            title={lang.createClient.connection.title}
            text={lang.createClient.connection.text}
            disabled={!isValid}
            onAbortButtonClick={onClose}
            onNextButtonClick={() => {
              if (!isValid) return false
              handleSubmit()

              return true
            }}
          >
            <Form className={classes.form}>
              <Radio
                name="connectionType"
                value={CONNECTION_TYPE_ONLINE}
                checked={values.connectionType === CONNECTION_TYPE_ONLINE || invitationMode}
                onChange={onChange}
              >
                <RadioContent
                  title={lang.createClient.connection.radio.invite}
                />
              </Radio>
              <br />
              <Radio
                name="connectionType"
                value={CONNECTION_TYPE_OFFLINE}
                checked={values.connectionType === CONNECTION_TYPE_OFFLINE}
                onChange={onChange}
                invitationMode={invitationMode}
                disabled={invitationMode}
              >
                <RadioContent
                  title={lang.createClient.connection.radio.nonInvite}
                  subtitle={lang.createClient.connection.radio.nonInviteHint}
                />
              </Radio>
            </Form>
          </PageWrapper>
        )
      }
      }
    </Formik>
  )
}
Connection.propTypes = {
  onClose: PropTypes.func,
  invitationMode: PropTypes.bool,
}
Connection.defaultProps = {
  onClose: () => {},
  invitationMode: false,
}

const useStyles = makeStyles(() => ({
  form: {
    width: '100%',
    flexGrow: 1,
  },
}))

export default Connection
